import { c as _c } from "react/compiler-runtime";
import HeadlineComponent from '../../headline/headline.component';
import PlaceholderComponent from '../../placeholder/placeholder.component';
import { Props as ProductCarouselProps } from '../tabbed-carousel/tabbed-carousel.component';
import { ReactElement } from 'react';
import bubbleStyles from '../../bubble-button/bubble-button.component.module.scss';
import styles from '../tabbed-carousel/tabbed-carousel.component.module.scss';
export type Props = Pick<ProductCarouselProps, 'componentId' | 'headline' | 'subHeadline' | 'headlineLink' | 'tabs'>;
export const CAROUSEL_HEIGHTS = [{
  sinceWidth: 0,
  height: 570
}, {
  sinceWidth: 768,
  height: 612
}, {
  sinceWidth: 1024,
  height: 632
}];
export default function ProductCarouselPlaceholderComponent(t0) {
  const $ = _c(27);
  const {
    componentId,
    headline,
    subHeadline,
    headlineLink,
    tabs
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let visibleTabs;
  if ($[0] !== componentId || $[1] !== headline || $[2] !== headlineLink || $[3] !== subHeadline || $[4] !== tabs) {
    visibleTabs = tabs.filter(_temp);
    t3 = styles["tabbed-carousel"];
    if ($[10] !== componentId || $[11] !== headline || $[12] !== headlineLink || $[13] !== subHeadline) {
      t4 = headline && <HeadlineComponent id={`${componentId}-placeholder-headline`} headline={headline} subHeadline={subHeadline} link={headlineLink} />;
      $[10] = componentId;
      $[11] = headline;
      $[12] = headlineLink;
      $[13] = subHeadline;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t1 = styles["tabbed-carousel"];
    t2 = visibleTabs.length > 1 && <div className={styles["tabbed-carousel__tabs-wrapper"]}>{visibleTabs.map(_temp4)}</div>;
    $[0] = componentId;
    $[1] = headline;
    $[2] = headlineLink;
    $[3] = subHeadline;
    $[4] = tabs;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = visibleTabs;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    visibleTabs = $[9];
  }
  let t5;
  if ($[15] !== componentId || $[16] !== visibleTabs[0] || $[17] !== visibleTabs.length) {
    t5 = visibleTabs.length > 0 && <div className={styles["tabbed-carousel__carousels-wrapper"]}><PlaceholderComponent id={`${componentId}-placeholder-carousel`} heightSinceWidth={[{
        sinceWidth: 0,
        height: "var(--product-carousel-min-height)"
      }]} />{visibleTabs[0].button && <div className={styles["tabbed-carousel__button-wrapper"]}><PlaceholderComponent id={`${componentId}-placeholder-button`} heightSinceWidth={[{
          sinceWidth: 0,
          height: 50
        }]} /></div>}</div>;
    $[15] = componentId;
    $[16] = visibleTabs[0];
    $[17] = visibleTabs.length;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t5) {
    t6 = <div className={t1}>{t2}{t5}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t3 || $[24] !== t4 || $[25] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}
function _temp4(tab) {
  return <span className={bubbleStyles["bubble-component"]} key={tab.metadata.find(_temp2)?.value ?? JSON.stringify([tab.headline, tab.products.map(_temp3)])}>{tab.headline}</span>;
}
function _temp3(t0) {
  const {
    code
  } = t0;
  return code;
}
function _temp2(t0) {
  const {
    key
  } = t0;
  return key === "mgnlTemplateAnnotation";
}
function _temp(t0) {
  const {
    products,
    hidden
  } = t0;
  return !hidden && products.length > 0;
}